import { Button, Dialog, styled } from '@mui/material';
import { Grid } from '@mui/system';

export const MarginTopGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const ActionButtonsGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const PaperSmDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root.MuiDialog-paperWidthSm': {
    maxWidth: '700px !important',
  },
}));

export const DangerButton = styled(Button)(({ theme }) => ({
  color: theme.palette.error.contrastText,
  backgroundColor: theme.palette.error.light,
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));